/**
 *
 * @export
 * @interface CreateLeadDto
 */
export interface CreateLeadDto
{
    /**
     *
     * @type {string}
     * @memberof CreateLeadDto
     */
    buildingType: BuildingTypeEnum;
    /**
     *
     * @type {ContactInformationDto}
     * @memberof CreateLeadDto
     */
    contactInformation: ContactInformationDto;
    /**
     *
     * @type {OfferDto}
     * @memberof CreateLeadDto
     */
    offer?: OfferDto;
    /**
     *
     * @type {string}
     * @memberof CreateLeadDto
     */
    source: string;
    /**
     *
     * @type {string}
     * @memberof CreateLeadDto
     */
    type?: TypeEnum;
    /**
     *
     * @type {number}
     * @memberof CreateLeadDto
     */
    yearlyEnergyConsumption?: number | undefined | null;
}

/**
 * @export
 * @enum {string}
 */
export enum BuildingTypeEnum
{
    EXISTING = <any>'EXISTING', NEW = <any>'NEW'
}

/**
 * @export
 * @enum {string}
 */
export enum TypeEnum
{
    SOLARANDBATTERY = <any>'SOLAR_AND_BATTERY', SOLAR = <any>'SOLAR', BATTERY = <any>'BATTERY'
}

/**
 *
 * @export
 * @interface CreateLeadResultDto
 */
export interface CreateLeadResultDto
{
    /**
     *
     * @type {string}
     * @memberof CreateLeadResultDto
     */
    contact?: string;
    /**
     *
     * @type {number}
     * @memberof CreateLeadResultDto
     */
    project?: number;
}

/**
 *
 * @export
 * @interface ContactInformationDto
 */
export interface ContactInformationDto
{
    /**
     *
     * @type {boolean}
     * @memberof ContactInformationDto
     */
    digitalCounter?: boolean;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    email: string;
    /**
     *
     * @type {boolean}
     * @memberof ContactInformationDto
     */
    existingClient?: boolean;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    firstName: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    fixedPhone?: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    houseNumber: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    language?: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    lastName: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    mailbox?: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    mobilePhone: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    vatNumber: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    postalCode: string;
    /**
     * Includes name of municipality
     * @type {string}
     * @memberof ContactInformationDto
     */
    fullPostalCode: string;
    /**
     *
     * @type {string}
     * @memberof ContactInformationDto
     */
    street: string;
}

/**
 *
 * @export
 * @interface OfferDto
 */
export interface OfferDto
{
    /**
     *
     * @type {BatteryOfferDto}
     * @memberof OfferDto
     */
    battery?: BatteryOfferDto;
    /**
     *
     * @type {SolarOfferDto}
     * @memberof OfferDto
     */
    solar?: SolarOfferDto;
}

/**
 *
 * @export
 * @interface BatteryOfferDto
 */
export interface BatteryOfferDto
{
    /**
     *
     * @type {number}
     * @memberof BatteryOfferDto
     */
    amount?: number;
    /**
     *
     * @type {string}
     * @memberof BatteryOfferDto
     */
    invertorBrand?: string;
}

/**
 *
 * @export
 * @interface SolarOfferDto
 */
export interface SolarOfferDto
{
    /**
     *
     * @type {number}
     * @memberof SolarOfferDto
     */
    amount?: number;
    /**
     *
     * @type {OfferRoofDto}
     * @memberof SolarOfferDto
     */
    roof?: OfferRoofDto;
}

/**
 *
 * @export
 * @interface OfferRoofDto
 */
export interface OfferRoofDto
{
    /**
     *
     * @type {number}
     * @memberof OfferRoofDto
     */
    height?: number;
    /**
     *
     * @type {number}
     * @memberof OfferRoofDto
     */
    length?: number;
    /**
     *
     * @type {string}
     * @memberof OfferRoofDto
     */
    material?: string;
    /**
     *
     * @type {string}
     * @memberof OfferRoofDto
     */
    orientation?: string;
    /**
     *
     * @type {number}
     * @memberof OfferRoofDto
     */
    slope?: number;
    /**
     *
     * @type {number}
     * @memberof OfferRoofDto
     */
    surface?: number;
    /**
     *
     * @type {number}
     * @memberof OfferRoofDto
     */
    width?: number;
}
